// @flow

import React from 'react';
import { getGeoOsmString } from '../../utils/geoOsm/utils';
import { colors } from '../../themes';
import Icon from '../../components/shared/Icons/Icon';
import styles from './locationStyles';

type Props = {
  geoInfo: {
    geoOsm: ?Array<GeoOsm>,
    numVisibleItems: number,
    postalCode: ?string,
  },
  withRichData: ?boolean,
};

const inlineStyles = {
  locationIcon: { marginLeft: '-1px' },
};

class LocationOsm extends React.Component<Props> {
  formattedLocation = () => {
    if (!this.props.geoInfo.geoOsm) {
      return null;
    }

    let geoOsm = getGeoOsmString(this.props.geoInfo.geoOsm, this.props.geoInfo.numVisibleItems);
    if (this.props.geoInfo.postalCode) {
      geoOsm = `${this.props.geoInfo.postalCode}, ${geoOsm}`;
    }

    return geoOsm;
  };

  render() {
    const location = this.formattedLocation();

    return (
      <div className="location">
        <Icon type="map" fill={colors.gray} width={13} style={inlineStyles.locationIcon} />
        <span
          className="location"
          itemScope={this.props.withRichData}
          itemProp="address"
          itemType="http://schema.org/Text"
        >
          {location}
        </span>
        <style jsx>{styles}</style>
      </div>
    );
  }
}

export default LocationOsm;



// WEBPACK FOOTER //
// ./app/common/Location/LocationOsm.js